import { SPEED, AMOUNT, EXAM } from './config.js';
import * as model from './model.js';
import {
    DOMstrings as DOM,
    startShow,
    instructionAnimateTop,
    render,
    showQuiz,
    restart,
    markAnswer,
    showStat,
    speedValidation,
    amountValidation,
    amountValueValidation,
    examValidation,
    examValueValidation,
    openSettings,
    closeSettings,
} from './view';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

let images, toQuiz, answer;

// 1. Get all images
const getSettings = () => {
    [images, toQuiz] = model.preloadImages();
};

// 2. Rendering images
// 2.1 Start
const showing = () => {
    startShow();
    setTimeout(() => instructionAnimateTop(), 1000);
    setTimeout(() => render(images, toQuiz, renderQuiz), 2000);
};

// 2.2 Stop
const stop = () => {
    [images, toQuiz] = model.preloadImages();
    round = 0;
    model.state.userAnswers.correct = 0;
    restart();
};

// 3. Render quiz
let round = 0;
const renderQuiz = () => {
    if (round > toQuiz.length - 1) {
        showStat(model.state);
        return;
    }

    answer = toQuiz[round][Math.round(Math.random() * 1)];
    console.log(answer);
    showQuiz(answer, model.state);
    round++;
};

// 4. Check answer
const getAnswer = (e) => {
    DOM.answersBtn.children.forEach((btn) => (btn.disabled = true));
    if (
        (e.target.id === 'yes' && images.some((img) => img.id === answer.id)) ||
        (e.target.id === 'no' && images.every((img) => img.id !== answer.id))
    ) {
        console.log(images, answer);
        markAnswer(e.target, true);
        model.state.userAnswers.correct++;
    } else {
        markAnswer(e.target, false);
    }

    console.log(model.state);
    setTimeout(() => {
        DOM.answersBtn.children.forEach((btn) => (btn.disabled = false));
        renderQuiz();
    }, 1000);
};

const init = function () {
    DOM.speed.value = DOM.speedSlider.value = SPEED.value + '';
    DOM.speed.min = DOM.speedSlider.min = SPEED.min + '';
    DOM.speed.max = DOM.speedSlider.max = SPEED.max + '';
    DOM.speed.step = DOM.speedSlider.step = SPEED.step + '';

    DOM.amount.value = DOM.amountSlider.value = AMOUNT.value + '';
    DOM.amount.min = DOM.amountSlider.min = AMOUNT.min + '';
    DOM.amount.max = DOM.amountSlider.max = AMOUNT.max + '';
    DOM.amount.step = DOM.amountSlider.step = AMOUNT.step + '';

    DOM.exam.value = DOM.examSlider.value = EXAM.value + '';
    DOM.exam.min = DOM.examSlider.min = EXAM.min + '';
    DOM.exam.max = DOM.examSlider.max = EXAM.max + '';
    DOM.exam.step = DOM.examSlider.step = EXAM.step + '';

    getSettings();

    DOM.speed.addEventListener('change', speedValidation);
    DOM.amount.addEventListener('change', amountValidation);
    DOM.amountSlider.addEventListener('change', amountValidation);
    DOM.exam.addEventListener('change', examValidation);
    DOM.examSlider.addEventListener('change', examValidation);

    DOM.startBtn.addEventListener('click', showing);
    DOM.stopBtn.addEventListener('click', stop);
    DOM.speed.addEventListener('change', getSettings);
    DOM.amount.addEventListener('change', getSettings);
    DOM.amountSlider.addEventListener('change', getSettings);
    DOM.exam.addEventListener('change', getSettings);
    DOM.examSlider.addEventListener('change', getSettings);
    DOM.yes.addEventListener('click', getAnswer);
    DOM.no.addEventListener('click', getAnswer);
    DOM.statistics.addEventListener('click', (e) => {
        if (e.target.closest('.btn-restart')) stop();
    });

    DOM.nut.addEventListener('click', openSettings);
    DOM.settings.addEventListener('click', closeSettings);
    document.addEventListener('keydown', closeSettings);
};

init();
